import { CarrotPlansPaths } from "#/utils/Paths"

const ROUTING_FLOW_PATH_MAP: Record<string, CarrotPlansPaths> = {
  [CarrotPlansPaths.ENROLLMENT]: CarrotPlansPaths.ENROLLMENT,
  [CarrotPlansPaths.CASE_RATE_RENEWAL]: CarrotPlansPaths.CASE_RATE_RENEWAL,
  [CarrotPlansPaths.CHECK_IN_EXPERIENCE]: CarrotPlansPaths.CHECK_IN_EXPERIENCE,
  [CarrotPlansPaths.JOURNEY_CHANGE]: CarrotPlansPaths.JOURNEY_CHANGE
}

/**
 * Use useRoutingFlowPath hook instead of this function in React components
 */
export default function getCurrentRoutingFlowPath(): CarrotPlansPaths | null {
  const currentPathname = window.location.pathname
  return ROUTING_FLOW_PATH_MAP[currentPathname] ?? null
}

export function getIsCheckInFlow(): boolean {
  return getCurrentRoutingFlowPath() === CarrotPlansPaths.CHECK_IN_EXPERIENCE
}
